import { DishCategoryDto, DishUnitMeasurementDto } from '@/api/generated';

export const dishEditorTranslation = {
  attention: {
    expiring: 'Cennik się kończy',
    noPrice: 'Bez aktualnej ceny',
    noTags: 'Bez tagów',
  },
  browse: {
    counter: 'Danie {{number}} z {{count}}',
    empty: 'Brak dań do przejrzenia — zmień filtry listy.',
    keyboardHint:
      '← / → poprzednie i następne danie · Ctrl+S zapisuje · zmiany zapisują się przy przejściu',
    nextHint: 'Następne danie (→)',
    nextPage: 'Następne 50 dań',
    page: 'Strona {{number}} z {{count}}',
    previousHint: 'Poprzednie danie (←)',
    previousPage: 'Poprzednie 50 dań',
  },
  close: 'Zamknij',
  complete: 'Wszystkie wymagane pola są uzupełnione.',
  create: {
    createdEmpty: 'Tu pojawią się dania zapisane w tym oknie.',
    createdTitle: 'Dodane teraz ({{count}})',
    discardMessage: 'Wpisane danie nie zostało zapisane. Zamknąć okno i porzucić je?',
    kept: 'Przy „Zapisz i dodaj kolejne” zostaje: {{values}}',
    noPrice: 'bez ceny',
    saveAndAdd: 'Zapisz i dodaj kolejne',
    saveAndClose: 'Zapisz i zamknij',
    shortcutHint: 'Enter w polu „Cena sugerowana” albo Ctrl+S zapisuje i otwiera kolejne danie.',
    tips:
      'Klikaj pastylki od góry — po wyborze działu i rodzaju kursor sam przechodzi dalej. ' +
      'Cenę możesz dodać od razu albo później w przeglądaniu.',
    tipsTitle: 'Szybkie dodawanie',
    yearRound: 'cały rok',
  },
  discard: {
    confirm: 'Zamknij bez zapisu',
    message:
      'Danie ma zmiany, których nie da się zapisać, bo brakuje wymaganych pól. Zamknąć bez zapisu?',
    title: 'Niezapisane zmiany',
  },
  fields: {
    department: 'dział',
    measurement: 'porcja',
    name: 'nazwa',
    price: 'cena',
    season: 'sezonowość',
    type: 'rodzaj',
  },
  form: {
    active: 'Dostępność w ofertach',
    activeOff: 'Wyłączone',
    activeOn: 'Aktywne',
    categories: {
      [DishCategoryDto.Dessert]: 'Deser',
      [DishCategoryDto.Dish]: 'Potrawa',
      [DishCategoryDto.Drink]: 'Napój',
    },
    category: 'Kategoria',
    department: 'Dział',
    description: 'Opis / dodatki w cenie',
    descriptionPlaceholder: 'Co wchodzi w danie i jak jest podawane — trafia do oferty pod nazwą',
    diets: 'Diety',
    measurement: 'Porcja',
    measurementValue: 'Porcja ({{unit}})',
    name: 'Nazwa dania',
    namePlaceholder: 'np. Tatar z łososia na blinach',
    prices: 'Ceny (zł netto)',
    pricesCreateHint:
      'Opcjonalnie — bez ceny danie trafi do oferty z ceną z przelicznika. Okres podpowiada się z sezonowości.',
    pricesHint: 'Okresy cennika dania. Nowy okres zaczyna się najwcześniej jutro.',
    quickMeasurement: 'Szybki wybór',
    required: 'wymagane',
    season: 'Sezonowość',
    tags: 'Tagi',
    tagsHint: 'Podpowiedzi to tagi najczęstsze w tym dziale i rodzaju.',
    type: 'Rodzaj dania',
    typeHint: 'Na początku są rodzaje najczęstsze w wybranym dziale.',
    unit: 'Jednostka',
    units: {
      [DishUnitMeasurementDto.Gram]: 'gramy',
      [DishUnitMeasurementDto.Milliliter]: 'mililitry',
      [DishUnitMeasurementDto.Unit]: 'sztuki',
    },
  },
  openDetails: 'Otwórz kartę dania',
  previous: 'Poprzednie',
  prices: {
    add: 'Dodaj kolejny okres',
    added: 'Dodano cenę na okres {{period}}',
    addFirst: 'Dodaj pierwszą cenę',
    amounts: 'sug. {{suggested}} · min. {{minimum}} · FC {{foodCost}}',
    amountsMissing: 'Uzupełnij FC, cenę minimalną i sugerowaną — albo wyczyść wszystkie trzy.',
    cancel: 'Anuluj',
    changePeriod: 'Zmień okres',
    empty: 'Brak cennika — w ofercie pójdzie cena z przelicznika.',
    foodCost: 'FC porcji',
    fromFoodCost: 'Wylicz ceny z FC',
    fromFoodCostHint: 'wyliczenie: min. = FC / 0,4, sugerowana = FC / 0,3',
    immutableHint: 'Kwot zapisanego okresu się nie zmienia — dodaj nowy okres albo wyłącz błędny.',
    margin: 'marża {{value}}%',
    minimumMargin: 'marża przy cenie min.: {{value}}%',
    minimumSalePrice: 'Cena minimalna',
    multiplier: 'Mnożnik poza okresem',
    newPeriod: 'Nowy okres cennika',
    newPeriodFromLatest: 'Nowy okres — kwoty skopiowane z ostatniego',
    orderMinimumPortions: 'Min. zamówienie (porcje)',
    period: 'Okres obowiązywania',
    periodChanged: 'Zmieniono okres cennika',
    periodHint: 'Poza okresem cena = najbliższy okres × mnożnik.',
    presets: {
      endOfYear: 'Do końca roku',
      nextCalendarYear: 'Cały następny rok',
      season: 'Najbliższy sezon',
      year: 'Rok od startu',
    },
    problems: {
      notFuture: 'Okres musi zaczynać się najwcześniej jutro i kończyć w przyszłości.',
      order: 'Data „do” nie może być wcześniejsza niż „od”.',
      overlap: 'Okres nakłada się na inny aktywny okres tego dania.',
      season: 'Okres musi mieścić się w sezonowości dania i trwać najwyżej do następnego roku.',
    },
    save: 'Zapisz',
    saveNew: 'Zapisz cenę',
    seasonNotSaved:
      'Zmieniona sezonowość nie jest jeszcze zapisana — okres sprawdzamy według zapisanej.',
    showLess: 'Pokaż mniej',
    showOlder: 'Pokaż starsze ({{count}})',
    status: {
      current: 'Obowiązuje',
      future: 'Zaplanowany',
      off: 'Wyłączony',
      past: 'Minął',
    },
    suggestedMargin: 'przy sugerowanej: {{value}}%',
    suggestedSalePrice: 'Cena sugerowana',
    switchedOff: 'Wyłączono okres cennika',
    switchedOn: 'Włączono okres cennika',
    switchOff: 'Wyłącz',
    switchOn: 'Włącz',
    validFrom: 'Ważne od',
    validTo: 'Ważne do',
  },
  priceValidUntil: 'Cennik do {{date}}',
  remaining: 'Uzupełnij: {{fields}}',
  save: 'Zapisz',
  saveAndClose: 'Zapisz i zamknij',
  saveAndFinish: 'Zapisz i zakończ',
  saveAndNext: 'Zapisz i dalej',
  saved: 'Zapisano',
  saving: 'Zapisywanie…',
  similar: {
    inactive: 'wyłączone',
    sameName: 'Danie o tej nazwie już jest w katalogu — sprawdź, zanim dodasz drugie:',
    title: 'Podobne dania w katalogu:',
  },
  status: {
    active: 'Aktywne',
    inactive: 'Wyłączone',
  },
  titleBrowse: 'Przeglądanie dań',
  titleCreate: 'Nowe danie',
  titleEdit: 'Edycja dania',
  toast: {
    created: 'Dodano danie „{{name}}”',
    missing: 'Uzupełnij: {{fields}}',
    saved: 'Zapisano „{{name}}”',
    savedWithoutPrice: 'Danie „{{name}}” zapisane bez ceny — dodaj ją w przeglądaniu dań.',
  },
  unsaved: 'Niezapisane zmiany',
};

export type DishEditorTranslation = typeof dishEditorTranslation;
